import {css} from 'styled-components';

export default css`

    body,
    button,
    input,
    optgroup,
    select,
    textarea {
      font-family: 'Lato';
    }
`;
